/* Maison Vinum — barre d'achat collante.
   Deplacee dans <body> : la colonne produit de Dawn est animee (transform),
   ce qui ancrait le position:fixed sur la colonne au lieu de l'ecran.
   L'ajout passe par le tiroir panier, comme le bouton principal. */
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this); // re-declenche connectedCallback
          return;
        }
        if (this.dataset.ready) return;
        this.dataset.ready = '1';
        if (this.dataset.always === 'true') this.classList.add('is-visible');
        else this.watchAnchor();
        this.bindVariant();
        this.bindSubmit();
      }

      watchAnchor() {
        const anchor =
          document.querySelector('product-form .product-form__submit') ||
          document.querySelector('.product-form__buttons') ||
          document.querySelector('.product__info-container');
        if (!anchor) return this.classList.add('is-visible');
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            this.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          });
        });
        this.observer.observe(anchor);
      }

      bindVariant() {
        const select = this.querySelector('[data-satc-select]');
        const price = this.querySelector('[data-satc-price]');
        if (select && price) {
          select.addEventListener('change', () => {
            const opt = select.options[select.selectedIndex];
            if (opt && opt.dataset.price) price.textContent = opt.dataset.price;
          });
        }
        document.addEventListener('change', (ev) => {
          if (!select || !ev.target.closest('variant-selects')) return;
          const main = document.querySelector('product-form [name="id"]');
          if (main && select.querySelector(`option[value="${main.value}"]`)) {
            select.value = main.value;
            select.dispatchEvent(new Event('change'));
          }
        });
      }

      bindSubmit() {
        const form = this.querySelector('form');
        if (!form) return;
        form.addEventListener('submit', (e) => {
          // le tiroir est cherche au clic : son script peut se charger apres celui-ci
          const cart = document.querySelector('cart-drawer');
          if (!cart || typeof cart.renderContents !== 'function' || !window.routes) return; // envoi classique
          e.preventDefault();
          const btn = form.querySelector('[type="submit"]');
          btn.setAttribute('aria-disabled', 'true');
          const fd = new FormData(form);
          fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
          fd.append('sections_url', window.location.pathname);
          fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: fd,
          })
            .then((r) => r.json())
            .then((res) => {
              if (res.status) {
                window.location.href = window.routes.cart_url;
                return;
              }
              cart.classList.remove('is-empty');
              cart.renderContents(res);
            })
            .catch(() => {
              window.location.href = window.routes.cart_url;
            })
            .finally(() => btn.removeAttribute('aria-disabled'));
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
